"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dates = void 0;
exports.dates = {
    date2000: '2000-01-01T00:00:00.000Z',
    date2100: '2100-01-01T00:00:00.000Z',
};
